import Vue from "vue";
import * as knows from "../../../static/json/knows.json";
//模块功能：航运知识
export default Vue.extend({
    name: "k-ship",
    data: function () {
        return {
            crtIndex: 0,
            detailShow: false,
        };
    },
    mounted: function () {
    },
    methods: {
        /**
         * 功能：显示新闻列表
         */
        backList: function () {
            this.detailShow = false;
        },
        /**
         * 功能：显示新闻详情
         * @param index
         */
        toDetail: function (index) {
            this.crtIndex = index;
            this.detailShow = true;
        }
    },
    computed: {
        knowList: function () {
            var temp = knows['data'];
            var url = "../../../static/img/knows/";
            for (var _i = 0, _a = temp['ship']; _i < _a.length; _i++) {
                var item = _a[_i];
                item.img = item.img == "" ? "" : url + item.img;
                for (var _b = 0, _c = item.contents; _b < _c.length; _b++) {
                    var item1 = _c[_b];
                    item1.img = item1.img == "" ? "" : url + item1.img;
                }
            }
            return temp;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/knows/k-ship.vue
// module id = null
// module chunks = 